<template>
  <v-container>
    <v-row justify="center">
      <v-chip-group
        v-model="typeFilter"
        justify-center
        mandatory
        active-class="primary"
      >
        <v-chip v-for="type in types" :key="type">
          {{ type }}
        </v-chip>
      </v-chip-group>
    </v-row>
    <v-row justify="center">
      <div style="position: relative">
        <v-badge
          :style="
            'position:absolute;left:' +
            getGridPositionLeft(grid) +
            'px;top:' +
            getGridPositionTop(grid) +
            'px'
          "
          :content="completed(grid) + '/' + total(grid)"
          inline
          v-show="total(grid) > 0"
          v-for="(grid, index) in filtered"
          :key="index"
        ></v-badge>

        <map name="ImageMap_1_66650762">
          <area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=F%C3%B6gas_(City)"
            shape="circle"
            coords="196,172,10"
            alt="Fögas"
            title="Fögas" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Freetown_(City)"
            shape="circle"
            coords="190,360,10"
            alt="Freetown"
            title="Freetown" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Friguld_(City)"
            shape="circle"
            coords="484,602,10"
            alt="Friguld"
            title="Friguld" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Icemist_(City)"
            shape="circle"
            coords="598,56,10"
            alt="Icemist"
            title="Icemist" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Jabal_(City)"
            shape="circle"
            coords="258,290,10"
            alt="Jabal"
            title="Jabal" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Kingsbridge_(City)"
            shape="circle"
            coords="420,341,10"
            alt="Kingsbridge"
            title="Kingsbridge" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Lamis_(City)"
            shape="circle"
            coords="107,43,10"
            alt="Lamis"
            title="Lamis" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Lannegar_(City)"
            shape="circle"
            coords="540,252,10"
            alt="Lannegar"
            title="Lannegar" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=New_Anthur_(City)"
            shape="circle"
            coords="688,267,10"
            alt="New Anthur"
            title="New Anthur" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=New_Garand_(City)"
            shape="circle"
            coords="480,437,10"
            alt="New Garand"
            title="New Garand" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Nivarian_(City)"
            shape="circle"
            coords="384,180,10"
            alt="Nivarian"
            title="Nivarian" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Port_Malan_(City)"
            shape="circle"
            coords="644,494,10"
            alt="Port Malan"
            title="Port Malan" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Rh%C3%B6neis_(City)"
            shape="circle"
            coords="331,246,10"
            alt="Rhöneis"
            title="Rhöneis" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Sanctuary_of_Irossia"
            shape="circle"
            coords="200,54,10"
            alt="Sanctuary of Irossia"
            title="Sanctuary of Irossia" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Solliga_(City)"
            shape="circle"
            coords="727,190,10"
            alt="Solliga"
            title="Solliga" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Sydarun_(City)"
            shape="circle"
            coords="338,440,10"
            alt="Sydarun"
            title="Sydarun" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Whitetower_(City)"
            shape="circle"
            coords="532,132,10"
            alt="Whitetower"
            title="Whitetower" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Ashen_Cape"
            shape="rect"
            coords="552,778,628,853"
            alt="Ashen Cape"
            title="Ashen Cape" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Ashen_Wastes"
            shape="rect"
            coords="476,778,551,853"
            alt="Ashen Wastes"
            title="Ashen Wastes" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Backwoods_Coven"
            shape="rect"
            coords="94,90,169,165"
            alt="Backwoods Coven"
            title="Backwoods Coven" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Crimson_Hills"
            shape="rect"
            coords="400,166,475,242"
            alt="Crimson Hills"
            title="Crimson Hills" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Deadwood"
            shape="rect"
            coords="323,319,399,395"
            alt="Deadwood"
            title="Deadwood" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Deepfrost_Glacier"
            shape="rect"
            coords="400,13,475,89"
            alt="Deepfrost Glacier"
            title="Deepfrost Glacier" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Dragon_Coast"
            shape="rect"
            coords="476,625,551,700"
            alt="Dragon Coast"
            title="Dragon Coast" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Eastern_Inori"
            shape="rect"
            coords="476,472,551,547"
            alt="Eastern Inori"
            title="Eastern Inori" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Eastern_Korne"
            shape="rect"
            coords="705,472,781,547"
            alt="Eastern Korne"
            title="Eastern Korne" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Eastern_Wyvern_Mountains"
            shape="rect"
            coords="629,90,704,165"
            alt="Eastern Wyvern Mountains"
            title="Eastern Wyvern Mountains" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Emerald_Valley"
            shape="rect"
            coords="400,548,475,624"
            alt="Emerald Valley"
            title="Emerald Valley" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Elder_Forest"
            shape="rect"
            coords="94,166,169,242"
            alt="Elder Forest"
            title="Elder Forest" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=F%C3%B6gas_Forest"
            shape="rect"
            coords="170,166,246,242"
            alt="Fögas Forest"
            title="Fögas Forest" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Golden_Cove"
            shape="rect"
            coords="476,548,551,624"
            alt="Golden Cove"
            title="Golden Cove" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Gorge_of_the_Silent_Kings"
            shape="rect"
            coords="323,548,399,624"
            alt="Gorge of the Silent Kings"
            title="Gorge of the Silent Kings" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Great_Inori"
            shape="rect"
            coords="400,472,475,547"
            alt="Great Inori"
            title="Great Inori" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Great_Plains"
            shape="rect"
            coords="247,166,322,242"
            alt="Great Plains"
            title="Great Plains" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Icemist_Fjord"
            shape="rect"
            coords="552,13,628,89"
            alt="Icemist Fjord"
            title="Icemist Fjord" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Imperial_Coast"
            shape="rect"
            coords="552,395,628,471"
            alt="Imperial Coast"
            title="Imperial Coast" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Iron_Valley"
            shape="rect"
            coords="170,319,246,395"
            alt="Iron Valley"
            title="Iron Valley" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Iross_Highlands"
            shape="rect"
            coords="170,90,246,165"
            alt="Iross Highlands"
            title="Iross Highlands" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Kingsbridge"
            shape="rect"
            coords="400,319,475,395"
            alt="Kingsbridge"
            title="Kingsbridge" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Lannegar_Valley"
            shape="rect"
            coords="476,243,551,318"
            alt="Lannegar Valley"
            title="Lannegar Valley" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Mount_Orogg"
            shape="rect"
            coords="94,13,169,89"
            alt="Mount Orogg"
            title="Mount Orogg" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Mount_Storme"
            shape="rect"
            coords="552,319,628,395"
            alt="Mount Storme"
            title="Mount Storme" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Nekhar_Valley"
            shape="rect"
            coords="170,243,246,318"
            alt="Nekhar Valley"
            title="Nekhar Valley" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=New_Anthur_Bay"
            shape="rect"
            coords="629,243,704,318"
            alt="New Anthur Bay"
            title="New Anthur Bay" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=New_Garand_Farmlands"
            shape="rect"
            coords="476,395,551,471"
            alt="New Garand Farmlands"
            title="New Garand Farmlands" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Nilomar_Cape"
            shape="rect"
            coords="629,395,704,471"
            alt="Nilomar Cape"
            title="Nilomar Cape" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Nivar_Wetlands"
            shape="rect"
            coords="323,166,399,242"
            alt="Nivar Wetlands"
            title="Nivar Wetlands" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=North_Jabal_Hills"
            shape="rect"
            coords="247,243,322,318"
            alt="North Jabal Hills"
            title="North Jabal Hills" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=North_Sagar_Forest"
            shape="rect"
            coords="552,166,628,242"
            alt="North Sagar Forest"
            title="North Sagar Forest" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Northern_Bluemist_River"
            shape="rect"
            coords="400,243,475,318"
            alt="Northern Bluemist River"
            title="Northern Bluemist River" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Northern_Inori"
            shape="rect"
            coords="400,395,475,471"
            alt="Northern Inori"
            title="Northern Inori" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Northwest_Sagar_Forest"
            shape="rect"
            coords="476,166,551,242"
            alt="Northwest Sagar Forest"
            title="Northwest Sagar Forest" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Rh%C3%B6neis_Plains"
            shape="rect"
            coords="323,243,399,318"
            alt="Rhöneis Plains"
            title="Rhöneis Plains" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Sanctuary_Peak"
            shape="rect"
            coords="170,13,246,89"
            alt="Sanctuary Peak"
            title="Sanctuary Peak" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Solligan_Stripe"
            shape="rect"
            coords="705,166,781,242"
            alt="Solligan Stripe"
            title="Solligan Stripe" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=South_Jabal_Hills"
            shape="rect"
            coords="247,319,322,395"
            alt="South Jabal Hills"
            title="South Jabal Hills" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=South_Sagar_Forest"
            shape="rect"
            coords="552,243,628,318"
            alt="South Sagar Forest"
            title="South Sagar Forest" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Southern_Bluemist_River"
            shape="rect"
            coords="476,319,551,395"
            alt="Southern Bluemist River"
            title="Southern Bluemist River" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Southern_Dragon_Mountains"
            shape="rect"
            coords="476,701,551,777"
            alt="Southern Dragon Mountains"
            title="Southern Dragon Mountains" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Steel_Coast"
            shape="rect"
            coords="629,319,704,395"
            alt="Steel Coast"
            title="Steel Coast" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Sydarun_Oasis"
            shape="rect"
            coords="323,395,399,471"
            alt="Sydarun Oasis"
            title="Sydarun Oasis" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=The_Trollfens"
            shape="rect"
            coords="247,395,322,471"
            alt="The Trollfens"
            title="The Trollfens" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Thyr_Ridges"
            shape="rect"
            coords="247,90,322,165"
            alt="Thyr Ridges"
            title="Thyr Ridges" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Varann_Woodland"
            shape="rect"
            coords="94,243,169,318"
            alt="Varann Woodland"
            title="Varann Woodland" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Western_Korne"
            shape="rect"
            coords="629,472,704,547"
            alt="Western Korne"
            title="Western Korne" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=White_Plains"
            shape="rect"
            coords="476,13,551,89"
            alt="White Plains"
            title="White Plains" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Whitetower_Valley"
            shape="rect"
            coords="476,90,551,165"
            alt="Whitetower Valley"
            title="Whitetower Valley" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Wyvern_Mountains"
            shape="rect"
            coords="552,90,628,165"
            alt="Wyvern Mountains"
            title="Wyvern Mountains" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Wyverntail_Valley"
            shape="rect"
            coords="629,166,704,242"
            alt="Wyverntail Valley"
            title="Wyverntail Valley" /><area
            href="https://www.exiledkingdoms.com/wiki/index.php?title=Zamohr_Mountains"
            shape="rect"
            coords="170,395,246,471"
            alt="Zamohr Mountains"
            title="Zamohr Mountains" /></map
        ><img
          alt=""
          src="https://www.exiledkingdoms.com/wiki/images/a/aa/World_Map.jpg"
          width="800"
          height="949"
          class="thumbimage"
          usemap="#ImageMap_1_66650762"
        />
      </div>
    </v-row>
  </v-container>
</template>


<script>
import { mapGetters, mapState } from "vuex";


export default {
  name: "Map",
  components: {},
  data: () => ({
    typeFilter: 0,
  }),
  computed: {
    ...mapState({
      filter: (state) => state.configurations.filter,
    }),
    ...mapGetters("entities/grids", ["filtered"]),
    types() {
      return ["outdoors", "towns", "buildings", "dungeons", "quests", "bosses", "secrets", "tomes"];
    },
  },
  methods: {
    completed(grid) {
      switch (this.types[this.typeFilter]) {
        case "areas":
        case "outdoors":
        case "towns":
        case "buildings":
        case "dungeons":
        case "quests":
        case "bosses":
          return grid[this.types[this.typeFilter]].filter(
            (item) => item.completed
          ).length;
        case "secrets":
        case "tomes":
          if (grid[this.types[this.typeFilter]].length > 0) {
            return grid[this.types[this.typeFilter]]
              .map((item) => item.completed)
              .reduce((prev, next) => prev + next);
          } else {
            return 0;
          }
        default:
          return 0;
      }
    },
    total(grid) {
      switch (this.types[this.typeFilter]) {
        case "areas":
        case "outdoors":
        case "towns":
        case "buildings":
        case "dungeons":
        case "quests":
        case "bosses":
          return grid[this.types[this.typeFilter]].length;

        case "secrets":
        case "tomes":
          if (grid[this.types[this.typeFilter]].length > 0) {
            return grid[this.types[this.typeFilter]]
              .map((item) => item.total)
              .reduce((prev, next) => prev + next);
          } else {
            return 0;
          }
        default:
          return 0;
      }
    },
    getGridPositionTop(grid) {
      return (14 - grid.id.match(/[0-9]+/gi)[0]) * 76 - 35;
    },
    getGridPositionLeft(grid) {
      return (grid.id.match(/[A-Z]+/gi)[0].charCodeAt(0) - 65) * 76 - 37;
    },
  },
};
</script>
